import { logEvent, setUserId, setUserProperties } from 'firebase/analytics';
import { analytics } from '../config/firebase';
import { SSOProvider } from '../config/authorizedDomains';

// User Login Events
export const trackUserLogin = (provider: SSOProvider, userEmail: string, companyDomain: string, userId?: string) => {
  if (!analytics) return;
  
  logEvent(analytics, 'login', {
    method: provider,
    company_domain: companyDomain,
    user_id_custom: userId,
    timestamp: new Date().toISOString()
  });
};

export const trackUserLogout = (userEmail: string, sessionDuration?: number) => {
  if (!analytics) return;
  
  logEvent(analytics, 'logout', {
    session_duration: sessionDuration,
    timestamp: new Date().toISOString()
  });
};

// User Properties
export const setUserAnalyticsProperties = (userId: string, userEmail: string, companyDomain: string, role: string) => {
  if (!analytics) return;
  
  setUserId(analytics, userId);
  setUserProperties(analytics, {
    company_domain: companyDomain,
    user_role: role,
    company_name: companyDomain.split('.')[0]  // Just company name
  });
};

// Page View Events
export const trackPageView = (pageName: string, userId?: string) => {
  if (!analytics) return;
  
  logEvent(analytics, 'page_view', {
    page_title: pageName,
    user_id: userId,
    timestamp: new Date().toISOString()
  });
};

// FlashCheck Events
export const trackFlashCheckUpload = (userId: string, fileType: string, fileSize: number) => {
  if (!analytics) return;
  
  logEvent(analytics, 'flashcheck_upload', {
    user_id: userId,
    file_type: fileType,
    file_size: fileSize,
    timestamp: new Date().toISOString()
  });
};

export const trackFlashCheckResult = (userId: string, requestId: string, success: boolean, creditsUsed: number) => {
  if (!analytics) return;
  
  logEvent(analytics, 'flashcheck_result', {
    user_id: userId,
    request_id: requestId,
    success: success,
    credits_used: creditsUsed,
    timestamp: new Date().toISOString()
  });
};

// Credit Events
export const trackCreditTransaction = (userId: string, type: 'purchase' | 'usage', amount: number, remainingBalance: number) => {
  if (!analytics) return;
  
  logEvent(analytics, 'credit_transaction', {
    user_id: userId,
    transaction_type: type,
    amount: amount,
    remaining_balance: remainingBalance,
    timestamp: new Date().toISOString()
  });
};

// Error Events
export const trackError = (errorType: string, errorMessage: string, userId?: string) => {
  if (!analytics) return;
  
  logEvent(analytics, 'error_occurred', {
    error_type: errorType,
    error_message: errorMessage,
    user_id: userId,
    timestamp: new Date().toISOString()
  });
};
